

import { OpaUser } from '@brg/api';
import { Avatar } from '@brg/ui';
import { FC, ReactNode } from 'react';
import { DesignerCardLayout, DesignerCardLayoutNew, DesignerOpaCardLayoutNew } from './designerCardLayout';
import { CombinedEvents } from 'shared/helpers/projectEvents';
import { IDesignerLight } from 'shared/common';
import { SUBSCRIBE_VISIBILITY_STATUS } from '../Subscribe/const';

export interface DesignerCardProps {
    isLoading?: boolean;
    avatar?: string;
    designer?: IDesignerLight;
    name?: string;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    about?: string;
    isMe?: any;
    surName?: string;
    tooltip?: any;
    identifier?: string;
    onClick?: (identifier: string) => void;
    onSelect?: (id: string) => void;
    opaUser?: OpaUser;
    withRating?: boolean;
    showOpa?: boolean;
    isOpaCard?: boolean;
    isSelectable?: boolean
    alreadyProject?: boolean;
    selected?: boolean;
    isGroupModal?: boolean;
    handlers?: CombinedEvents;
    twoMobileColumns?: boolean;
    more?: ReactNode;
    isMobileMoreVisible?: boolean;
    href?: string;
    openInNewTab?: boolean;
    entityType?: string;
}

export const DesignerCard: FC<DesignerCardProps> = (props) => {
    const { isLoading, avatar, name, surName, visibility, identifier, onClick, opaUser, withRating, alreadyProject, isSelectable, selected } = props;
    const onClickGenerator = (id: string) => () => onClick?.(id);

    return (
        // @ts-ignore
        <DesignerCardLayout
            onClick={onClickGenerator(identifier ?? '')}
            avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
            title={name + ' ' + surName}
            isLoading={isLoading}
            opaUser={opaUser}
            withRating={withRating}
        />
    );
};
export const DesignerCardNew: FC<DesignerCardProps> = (props) => {
    const { isLoading, avatar, name, surName, visibility, more, isMe, designer, identifier, isMobileMoreVisible, onClick, entityType, tooltip, opaUser, withRating, showOpa, isOpaCard, isSelectable, alreadyProject, selected, onSelect, isGroupModal, twoMobileColumns, href, openInNewTab, ...handlers } = props;
    const onClickGenerator = (id: string) => () => onClick?.(id);

    return (
        <>
            {!isOpaCard ? (
                <DesignerCardLayoutNew
                    showOpa={showOpa}
                    designer={designer}
                    isMobileMoreVisible={isMobileMoreVisible}
                    onClick={onClickGenerator(identifier ?? '')}
                    avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
                    title={surName + ' ' + name}
                    visibility={visibility}
                    tooltip={tooltip}
                    isLoading={isLoading}
                    opaUser={opaUser}
                    more={more}
                    withRating={withRating}
                    isSelectable={isSelectable}
                    alreadyProject={alreadyProject}
                    selected={selected}
                    onSelect={onSelect}
                    identifier={identifier}            
                    isGroupModal={isGroupModal}
                    twoMobileColumns={twoMobileColumns}
                    isMe={isMe}
                    href={href}
                    openInNewTab={openInNewTab}
                    entityType={entityType}
                    {...handlers}
                />
            ) : (
                // @ts-ignore
                <DesignerOpaCardLayoutNew 
                    showOpa={showOpa}
                    designer={designer}
                    onClick={onClickGenerator(identifier ?? '')}
                    avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
                    title={surName + ' ' + name}
                    isLoading={isLoading}
                    opaUser={opaUser}
                    withRating={withRating}
                    href={href}
                    openInNewTab={openInNewTab}
                />
            )}
        </>
    );
};


import { OpaUser } from '@brg/api';
import { Avatar } from '@brg/ui';
import { FC, ReactNode } from 'react';
import { DesignerCardLayout, DesignerCardLayoutNew, DesignerOpaCardLayoutNew } from './designerCardLayout';
import { CombinedEvents } from 'shared/helpers/projectEvents';
import { IDesignerLight } from 'shared/common';
import { SUBSCRIBE_VISIBILITY_STATUS } from '../Subscribe/const';

export interface DesignerCardProps {
    isLoading?: boolean;
    avatar?: string;
    designer?: IDesignerLight;
    name?: string;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    about?: string;
    isMe?: any;
    surName?: string;
    tooltip?: any;
    identifier?: string;
    onClick?: (identifier: string) => void;
    onSelect?: (id: string) => void;
    opaUser?: OpaUser;
    withRating?: boolean;
    showOpa?: boolean;
    isOpaCard?: boolean;
    isSelectable?: boolean
    alreadyProject?: boolean;
    selected?: boolean;
    isGroupModal?: boolean;
    handlers?: CombinedEvents;
    twoMobileColumns?: boolean;
    more?: ReactNode;
    isMobileMoreVisible?: boolean;
    href?: string;
    openInNewTab?: boolean;
    entityType?: string;
}

export const DesignerCard: FC<DesignerCardProps> = (props) => {
    const { isLoading, avatar, name, surName, visibility, identifier, onClick, opaUser, withRating, alreadyProject, isSelectable, selected } = props;
    const onClickGenerator = (id: string) => () => onClick?.(id);

    return (
        // @ts-ignore
        <DesignerCardLayout
            onClick={onClickGenerator(identifier ?? '')}
            avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
            title={name + ' ' + surName}
            isLoading={isLoading}
            opaUser={opaUser}
            withRating={withRating}
        />
    );
};
export const DesignerCardNew: FC<DesignerCardProps> = (props) => {
    const { isLoading, avatar, name, surName, visibility, more, isMe, designer, identifier, isMobileMoreVisible, onClick, entityType, tooltip, opaUser, withRating, showOpa, isOpaCard, isSelectable, alreadyProject, selected, onSelect, isGroupModal, twoMobileColumns, href, openInNewTab, ...handlers } = props;
    const onClickGenerator = (id: string) => () => onClick?.(id);

    return (
        <>
            {!isOpaCard ? (
                <DesignerCardLayoutNew
                    showOpa={showOpa}
                    designer={designer}
                    isMobileMoreVisible={isMobileMoreVisible}
                    onClick={onClickGenerator(identifier ?? '')}
                    avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
                    title={surName + ' ' + name}
                    visibility={visibility}
                    tooltip={tooltip}
                    isLoading={isLoading}
                    opaUser={opaUser}
                    more={more}
                    withRating={withRating}
                    isSelectable={isSelectable}
                    alreadyProject={alreadyProject}
                    selected={selected}
                    onSelect={onSelect}
                    identifier={identifier}            
                    isGroupModal={isGroupModal}
                    twoMobileColumns={twoMobileColumns}
                    isMe={isMe}
                    href={href}
                    openInNewTab={openInNewTab}
                    entityType={entityType}
                    {...handlers}
                />
            ) : (
                // @ts-ignore
                <DesignerOpaCardLayoutNew 
                    showOpa={showOpa}
                    designer={designer}
                    onClick={onClickGenerator(identifier ?? '')}
                    avatar={<Avatar avatar={avatar} key={identifier} name={name} surName={surName} fs={50} />}
                    title={surName + ' ' + name}
                    isLoading={isLoading}
                    opaUser={opaUser}
                    withRating={withRating}
                    href={href}
                    openInNewTab={openInNewTab}
                />
            )}
        </>
    );
};
